export * from '@primeuix/themes/material/virtualscroller';
export { default } from '@primeuix/themes/material/virtualscroller';
